import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'

const modelName = 'option'

export function get () {
  return {
    types: generateTypes(`${modelName}s`),
    api: api => api(`${modelName}s`)
  }
}

export const actions = {
  get
}

// Action Handlers
const initialState = []
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName, tempId: 'name' })

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Options/modules/options.js